import React from "react";
import "./side-by-stretch.scss";

const SideByStretch = ({imgSrc, children}) => (
  <div className="side-by">
    <div className="side-by-image" style={{ "background-image": `url(${imgSrc})` }}></div>
    <div className="side-by-content">
      {children}
    </div>
  </div>
);

export default SideByStretch;
